import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 63169 62686"
    {...props}
  >
    <path
      d="M4283 49372c607-790 1247-1574 1915-2353 768 1046 4392 4802 5316 5763-420 412-1687 1676-2100 2057-842-873-4410-4531-5131-5467zm48865 1692c416 413 1703 1673 2084 2074-881 833-4585 4356-5533 5072-798-601-1595-1233-2385-1897 1059-753 4861-4336 5834-5249zM30416 30327c1339-1361 3473 746 2093 2066-1339 1365-3470-743-2093-2066zM8252 10151c-197-193-382-382-558-567 883-832 4586-4353 5534-5067 798 597 1593 1229 2381 1893-1057 755-4859 4338-5830 5248l-1527-1507zm43161-207c420-412 1688-1684 2099-2058 842 871 4408 4528 5132 5466-609 787-1247 1573-1917 2354-765-1046-4393-4804-5314-5762zM765 58754c6063 4192 22780-18377 27543-21527 1205 634 2549 882 3872 740 2861 7796 12301 18146 20314 23122 8191 4982 10006-2717 2704-9032 2-2-17794-17578-17794-17578 638-1191 890-2519 748-3825 7897-2830 18366-12146 23411-20065 5124-8983-3126-9290-9148-2669L34620 25494c-1205-631-2549-878-3876-738-2860-7799-12296-18141-20311-23124C5797-1461 1399-172 3810 5626c1586 3841 18699 19225 21713 22617-640 1192-890 2519-749 3827C18874 33667-4492 51386 765 58754z"
      style={{
        fill: "#000",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
